export default [
  {
    "name": "Channel Islands",
    "values": [
      { name: 'Jersey', abbreviation: 'JE' },
      { name: 'Guernsey', abbreviation: 'GG' },
      { name: 'Alderney', abbreviation: 'AL' },
      { name: 'Herm', abbreviation: 'HM' },
      { name: 'Sark', abbreviation: 'SK' },
    ],
  },
]